// ** React Imports
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { ADMIN_ROUTES } from "../../constant/route";
import EditStyleProfile from "../../views/apps/styleProfile/EditStyleProfile";
import { ROLE } from "../../constant/constant";
import EditorsMaster from "../../views/admin/editorsMaster/EditorsMaster";
import ArchivedProjects from "../../views/admin/archivedProjects/ArchivedProjects";
import EditorsMasterTabs from "../../views/admin/editorsMaster/EditorsMasterTabs";
// import ClientDetail from "../../views/admin/clientManagement/clientDetail/ClientDetail";
// import ClientManagement from "../../views/admin/clientManagemen";

const ClientManagement = lazy(() =>
  import("../../views/admin/clientManagement")
);
const ClientDetail = lazy(() =>
  import("../../views/admin/clientManagement/clientDetail/ClientDetail")
);

const DiscountCoupon = lazy(() =>
  import("../../views/admin/discountCoupon/DiscountCouponTable")
);

const ProjectManagement = lazy(() =>
  import("../../views/admin/projectManagement")
);

const ProjectInfo = lazy(() =>
  import("../../views/admin/projectManagement/projectInfo/projectInfo")
);

const PopupManagement = lazy(() =>
  import("../../views/admin/popupManagement/PopupManagement")
);

const AdminRoutes = [
  {
    element: <ClientManagement />,
    path: ADMIN_ROUTES.CLIENT_MANAGEMENT,
    roles: [ROLE.ADMIN],
  },
  {
    element: <DiscountCoupon />,
    path: ADMIN_ROUTES.DISCOUNT_COUPON,
    roles: [ROLE.ADMIN],
  },
  {
    element: <ClientDetail />,
    path: ADMIN_ROUTES.CLIENT_DETAIL,
    meta: {
      className: "client-detail",
    },
    roles: [ROLE.ADMIN],
  },
  {
    element: <ProjectManagement />,
    path: ADMIN_ROUTES.PROJECT_MANAGEMENT,
    roles: [ROLE.ADMIN],
  },

  {
    element: <ProjectInfo />,
    path: ADMIN_ROUTES.PROJECT_INFO,
    roles: [ROLE.ADMIN],
  },
  {
    element: <EditStyleProfile />,
    path: ADMIN_ROUTES.STYLE_PROFILE_VIEW,
    roles: [ROLE.ADMIN],
  },
  // {
  //   element: <PopupManagement />,
  //   path: ADMIN_ROUTES.POPUP_MAGEMENT,
  //   roles: [ROLE.ADMIN],
  // },
  {
    element: <PopupManagement />,
    path: ADMIN_ROUTES.POPUP_MANAGEMENT_PROJECT,
    roles: [ROLE.ADMIN],
  },
  {
    element: <PopupManagement />,
    path: ADMIN_ROUTES.POPUP_MANAGEMENT_ORDER,
    roles: [ROLE.ADMIN],
  },
  {
    element: <PopupManagement />,
    path: ADMIN_ROUTES.POPUP_MANAGEMENT_SUBSCRIPTION,
    roles: [ROLE.ADMIN],
  },
  {
    element: <EditorsMasterTabs />,
    path: ADMIN_ROUTES.EDITORS_MASTER,
    roles: [ROLE.ADMIN],
  },

  {
    element: <ArchivedProjects />,
    path: ADMIN_ROUTES.ARCHIVED_PROJECTS,
    roles: [ROLE.ADMIN],
  },
];

export default AdminRoutes;
